import { Box, Icon, Text, Timer } from '@betty/moonlight';
import { memo } from 'react';
import QuestProgress from '../QuestProgress/QuestProgress';
import { TimeAndProgressProps } from './TimeAndProgress.types';
import { useTranslation } from '@betty/i18n';
import { QuestStatus } from '../../../../services/QuestsService.schemas';

function TimeAndProgress({
  id,
  questHasStarted,
  detailsPageView,
  status,
  subPromoType,
  subTypeMeta,
}: TimeAndProgressProps) {
  const { t } = useTranslation('quests');
  const timer = questHasStarted
    ? subTypeMeta.expiryDate
    : subTypeMeta.startDate;

  return (
    <>
      <Box
        flexDirection="row"
        alignItems="center"
        borderTopWidth="border-width-025"
        borderColor="borderSecondary"
        paddingTop="space-400"
      >
        <Icon
          name="timer"
          width={20}
          height={20}
          gradient="accentBackground"
          marginRight="space-200"
        />
        <Text variant="body-m-semi" color="darkSurfacePrimary">
          {t(questHasStarted ? 'endsIn' : 'startsIn')}{' '}
        </Text>
        <Timer
          key={id}
          color="darkSurfacePrimary"
          variant="body-m-semi"
          time={timer}
        />
      </Box>
      {!detailsPageView &&
      questHasStarted &&
      status !== QuestStatus.Completed &&
      status !== QuestStatus.Locked ? (
        <QuestProgress
          subTypeMeta={subTypeMeta}
          subPromoType={subPromoType}
          showLeftLabel={true}
        />
      ) : null}
    </>
  );
}

export default memo(TimeAndProgress);
